import { type ParsedQuery } from 'query-string'
import { createContext } from 'react'

export const ParameterContext = createContext<ParsedQuery>({})
